import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { IconFlare } from '@tabler/icons';
// constant
const icons = { IconFlare };

// material-ui
import { Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// project imports
import config from 'config';
import { MENU_OPEN } from 'store/actions';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
  const defaultId = useSelector((state) => state.customization.defaultId);
  const dispatch = useDispatch();
  const theme = useTheme();
  return (
    <Button
      variant="contained"
      sx={{
        bgcolor: 'secondary.200',
        color: '#ffffff',
        fontSize: '1.2rem',
        paddingX: '2rem',
        '&:hover': {
          background: theme.palette.secondary.dark,
          color: theme.palette.secondary.light
        }
      }}
      endIcon={<icons.IconFlare />}
      onClick={() => dispatch({ type: MENU_OPEN, id: defaultId })}
      component={Link}
      to={config.defaultPath}
      disableElevation
    >
      goldrush
    </Button>
  );
};

export default LogoSection;
